import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Plus, Trash2, Pencil } from "lucide-react";
import api from "@/lib/api";

const blank = { slug: "", name: "", image: "", order: 99, priority: 3, short: "", description: "", seo_title: "" };

export default function CategoriesAdmin() {
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(blank); setEditing(false); setOpen(true); };
  const openEdit = (c) => { setForm(c); setEditing(true); setOpen(true); };
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.slug || !form.name) { toast.error("Preencha slug e nome."); return; }
    const payload = { ...form, order: Number(form.order), priority: Number(form.priority) };
    try {
      if (editing) await api.put(`/admin/categories/${form.slug}`, payload);
      else await api.post("/admin/categories", payload);
      toast.success("Categoria salva"); setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Erro"); }
  };

  const del = async (slug) => { if (!window.confirm("Excluir categoria?")) return; await api.delete(`/admin/categories/${slug}`); load(); toast.success("Excluída"); };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div><h1 className="font-heading text-2xl font-bold text-white">Categorias</h1><p className="mt-1 text-sm text-[#A1A1AA]">Linhas de equipamentos do portfólio.</p></div>
        <Button data-testid="category-new-button" onClick={openNew} className="rounded-none bg-[#FF5500] font-bold hover:bg-[#CC4400]"><Plus className="mr-1 h-4 w-4" /> Nova</Button>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
        {cats.map((c) => (
          <div key={c.slug} data-testid={`category-card-${c.slug}`} className="flex items-center justify-between border border-[#27272A] bg-[#151618] p-4">
            <div className="flex items-center gap-3"><img src={c.image} alt="" className="h-10 w-10 object-cover" /><span className="text-sm font-medium text-white">{c.name}</span></div>
            <div className="flex gap-2">
              <button onClick={() => openEdit(c)} data-testid={`category-edit-${c.slug}`}><Pencil className="h-4 w-4 text-[#A1A1AA] hover:text-white" /></button>
              <button onClick={() => del(c.slug)} data-testid={`category-delete-${c.slug}`}><Trash2 className="h-4 w-4 text-[#71717A] hover:text-red-400" /></button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto rounded-none border-[#27272A] bg-[#151618] text-white" data-testid="category-dialog">
          <DialogHeader><DialogTitle className="font-heading">{editing ? "Editar categoria" : "Nova categoria"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="label-eyebrow">Slug *</Label><Input data-testid="category-form-slug" disabled={editing} value={form.slug} onChange={(e) => set("slug", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
              <div><Label className="label-eyebrow">Nome *</Label><Input data-testid="category-form-name" value={form.name} onChange={(e) => set("name", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
            </div>
            <div><Label className="label-eyebrow">Imagem (URL)</Label><Input data-testid="category-form-image" value={form.image} onChange={(e) => set("image", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
            <div><Label className="label-eyebrow">Descrição curta</Label><Input data-testid="category-form-short" value={form.short} onChange={(e) => set("short", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
            <div><Label className="label-eyebrow">Descrição</Label><Textarea data-testid="category-form-desc" value={form.description} onChange={(e) => set("description", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="label-eyebrow">Ordem</Label><Input data-testid="category-form-order" type="number" value={form.order} onChange={(e) => set("order", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
              <div><Label className="label-eyebrow">Prioridade</Label><Input data-testid="category-form-priority" type="number" value={form.priority} onChange={(e) => set("priority", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
            </div>
            <Button data-testid="category-form-save" onClick={save} className="w-full rounded-none bg-[#FF5500] font-bold hover:bg-[#CC4400]">Salvar</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
